import React from "react";
import { useTheme } from "@mui/material/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Box,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const MessageModal = ({ open, onClose, title, fields = [] }) => {
  const theme = useTheme();
  const [formData, setFormData] = React.useState({});

  React.useEffect(() => {
    // Initialize form data based on fields
    const initialData = {};
    fields.forEach((field) => {
      initialData[field.name] = field.defaultValue || "";
    });
    setFormData(initialData);
  }, [fields, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { borderRadius: theme.shape.borderRadius, overflow: "hidden" },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" fontWeight="bold">
          {title || "Message"}
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 3 }}>
        <Grid container spacing={2}>
          {fields.map((field, idx) => (
            <Grid item xs={12} sm={field.fullWidth ? 12 : 6} key={idx}>
              <TextField
                fullWidth
                type={field.type || "text"}
                label={field.label}
                name={field.name}
                value={formData[field.name] || ""}
                onChange={handleChange}
                multiline={field.multiline || false}
                rows={field.rows || 1}
                disabled // Making fields disabled as this is just for viewing purpose
              />
            </Grid>
          ))}
        </Grid>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", p: 2 }}>
        <Button onClick={onClose} variant="outlined" sx={{ px: 4 }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MessageModal;
